var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg038Pig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 100 100",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m80 50c-3.665 0-8.789-2.122-11.38-4.714l-15.287-15.286v13.333c0 3.682-2.984 6.667-6.666 6.667h-6.667v-6.667h6.667v-33.103c-5.996.75-11.374 3.471-15.453 7.518-4.866 4.83-7.881 11.523-7.881 18.919h-6.666c0-8.776 3.418-16.739 8.965-22.692-4.863-2.631-10.241-3.975-15.632-3.975v80h43.333c7.334 0 17.575-4.241 22.761-9.427l13.906-13.906v-16.667zm-20 10c-1.843 0-3.333-1.491-3.333-3.333 0-1.84 1.49-3.334 3.333-3.334s3.333 1.494 3.333 3.334c0 1.842-1.49 3.333-3.333 3.333z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg038Pig);
export default __webpack_public_path__ + "static/media/038-pig.22dab31631003a9ec4401c5cb0a41419.svg";
export { ForwardRef as ReactComponent };